import { render, staticRenderFns } from "./UserLinkCompanyDialog.vue?vue&type=template&id=a3038696&scoped=true&"
import script from "./UserLinkCompanyDialog.vue?vue&type=script&lang=js&"
export * from "./UserLinkCompanyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3038696",
  null
  
)

export default component.exports